import { render, staticRenderFns } from "./DeliveryMenuMatrixView.vue?vue&type=template&id=42d1c563&scoped=true"
import script from "./DeliveryMenuMatrixView.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuMatrixView.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuMatrixView.vue?vue&type=style&index=0&id=42d1c563&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1c563",
  null
  
)

export default component.exports